export default __webpack_public_path__ + "static/media/market-uptrend.ed934282.png";